import { images } from '../constants';

const products = [
    {
        id: 1,
        image: images.product1Gallery1,
        name: "The Holy Quran",
        price: 20.00,
        disprice: 30.00,
        stock: 9,
        content: "A beautifully printed copy of the Holy Quran, designed for ease of reading and spiritual reflection.",
        description: "This edition of the Holy Quran features clear Arabic text alongside a trusted translation to help readers understand the divine message. Perfect for study, recitation, and gifting.",
        category: ["Holy Quran", "Prayer Mat"],
        tags: ["Quran", "Holy Book", "Islam"],
        gallery: {
            image1: images.product1Gallery1,
            image2: images.product1Gallery2,
            image3: images.product1Gallery3, 
            image4: images.product1Gallery4,
        },
        addInfo: [
            { id: 1, title: "Language", content: "Arabic with English Translation" },
            { id: 2, title: "Pages", content: "600" },
            { id: 3, title: "Size", content: "8 x 5 inches" }
        ],
        comments: [
            {
                id: 1,
                image: images.product1Review1,
                name: "Aisha Khan",
                date: "March 10, 2025",
                rating: 5,
                content: "A beautifully made Quran. The translation helps deepen my understanding."
            },
            {
                id: 2,
                image: images.product1Review2,
                name: "Mohammed Ali",
                date: "March 15, 2025",
                rating: 5,
                content: "Excellent quality and print. Highly recommended for every Muslim household."
            }
        ]
    },
    {
        id: 2,
        image: images.product2Gallery1, 
        name: "Pure Honey",
        price: 20.00,
        disprice: 30.00,
        stock: 5,
        content: "100% natural pure honey harvested from organic sources, perfect for daily use and health benefits.",
        description: "Our pure honey is carefully collected from trusted beekeepers, ensuring rich flavor and natural nutrients. Ideal for sweetening drinks, cooking, or as a natural remedy.",
        category: ["Pure Honey", "Sweet Dates"],
        tags: ["Honey", "Organic", "Natural"],
        gallery: {
            image1: images.product2Gallery1,
            image2: images.product2Gallery2,
            image3: images.product2Gallery3,
            image4: images.product2Gallery4,
        },
        addInfo: [
            { id: 1, title: "Weight", content: "500g Jar" },
            { id: 2, title: "Origin", content: "Organic Farms" },
            { id: 3, title: "Purity", content: "100% Pure and Natural" }
        ],
        comments: [
            {
                id: 1,
                image: images.product2Review1,
                name: "Sara Ahmed",
                date: "April 12, 2025",
                rating: 5,
                content: "The honey is fresh and delicious, perfect for my morning tea."
            },
            {
                id: 2,
                image: images.product2Review2,
                name: "Ali Hassan",
                date: "April 15, 2025",
                rating: 4,
                content: "Great quality honey with a rich taste. Highly recommend."
            }
        ]
    },
    {
        id: 3,
        image: images.product3Gallery1,
        name: "Premium Dates",
        price: 15.00,
        disprice: 25.00,
        stock: 3,
        content: "Fresh, premium-quality dates packed with natural sweetness and nutrients, perfect for snacks and Ramadan.",
        description: "Our premium dates are carefully selected from the finest farms, ensuring a soft texture and rich flavor. Ideal for healthy snacking, cooking, or gifting during special occasions.",
        category: ["Sweet Dates", "Pure Honey"],
        tags: ["Dates", "Natural", "Sweet"],
        gallery: {
            image1: images.product3Gallery1,
            image2: images.product3Gallery2,
            image3: images.product3Gallery3,
            image4: images.product3Gallery4,
        },
        addInfo: [
            { id: 1, title: "Weight", content: "1kg Pack" },
            { id: 2, title: "Origin", content: "Premium Farms" },
            { id: 3, title: "Quality", content: "Fresh and Soft" }
        ],
        comments: [
            {
                id: 1,
                image: images.product3Review1,
                name: "Fatima Noor",
                date: "March 10, 2025",
                rating: 5,
                content: "The dates are incredibly fresh and sweet — perfect for iftar."
            },
            {
                id: 2,
                image: images.product3Review2,
                name: "Omar Khalid",
                date: "March 12, 2025",
                rating: 4,
                content: "Good quality dates, great taste, and reasonable price."
            }
        ]
    },
    {
        id: 4,
        image: images.product4Gallery1,
        name: "Premium Attar",
        price: 35.00,
        disprice: 50.00,
        stock: 0,
        content: "Exquisite, long-lasting natural attar crafted from pure essential oils, perfect for daily use and special occasions.",
        description: "Our premium attar is made using traditional distillation methods, offering a rich, pleasant fragrance without any alcohol. Ideal for those seeking authentic and subtle scents.",
        category: ["Fragrant Attar", "Sweet Dates"],
        tags: ["Attar", "Perfume", "Natural"],
        gallery: {
            image1: images.product4Gallery1,
            image2: images.product4Gallery2,
            image3: images.product4Gallery3,
            image4: images.product4Gallery4,
        },
        addInfo: [
            { id: 1, title: "Volume", content: "15 ml" },
            { id: 2, title: "Fragrance Type", content: "Floral & Woody" },
            { id: 3, title: "Ingredients", content: "Pure Essential Oils" }
        ],
        comments: [
            {
                id: 1,
                image: images.product4Review1,
                name: "Aisha Khan",
                date: "April 15, 2025",
                rating: 5,
                content: "The scent is beautiful and lasts all day. Highly recommended!"
            },
            {
                id: 2,
                image: images.product4Review2,
                name: "Bilal Ahmed",
                date: "April 17, 2025",
                rating: 4,
                content: "Authentic and smooth fragrance, perfect for daily use."
            }
        ]
    },
    {
        id: 5,
        image: images.product5Gallery1,
        name: "Prayer Mat",
        price: 25.00,
        disprice: 40.00,
        stock: 10,
        content: "Comfortable and durable prayer mat featuring intricate Islamic designs, perfect for daily prayers at home or mosque.",
        description: "This deluxe prayer mat is made from soft, high-quality fabric with a non-slip backing. It offers ample cushioning and a beautiful pattern inspired by traditional Islamic art.",
        category: ["Prayer Mat", "Holy Quran"],
        tags: ["Prayer Mat", "Islamic", "Comfort"],
        gallery: {
            image1: images.product5Gallery1,
            image2: images.product5Gallery2,
            image3: images.product5Gallery3,
            image4: images.product5Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Velvet with Non-slip Backing" },
            { id: 2, title: "Dimensions", content: "70 x 40 inches" },
            { id: 3, title: "Weight", content: "500 grams" }
        ],
        comments: [
            {
                id: 1,
                image: images.product5Review1,
                name: "Fatima Ali",
                date: "June 1, 2025",
                rating: 5,
                content: "Very comfortable and beautiful design. I use it every day."
            },
            {
                id: 2,
                image: images.product5Review2,
                name: "Ahmed Raza",
                date: "June 3, 2025",
                rating: 4,
                content: "Good quality and nice pattern. Great value for the price."
            }
        ]
    },
    {
        id: 6,
        image: images.product6Gallery1,
        name: "Premium Attar",
        price: 35.00,
        disprice: 50.00,
        stock: 6,
        content: "A luxurious attar perfume with long-lasting fragrance inspired by traditional Islamic scents.",
        description: "Our premium attar perfume is crafted from natural oils and exotic ingredients, offering a rich, smooth aroma. Perfect for daily wear or special occasions, it’s alcohol-free and skin-friendly.",
        category: ["Fragrant Attar", "Prayer Mat"],
        tags: ["Perfume", "Attar", "Fragrance"],
        gallery: {
            image1: images.product6Gallery1,
            image2: images.product6Gallery2,
            image3: images.product6Gallery3,
            image4: images.product6Gallery4,
        },
        addInfo: [
            { id: 1, title: "Volume", content: "15 ml" },
            { id: 2, title: "Ingredients", content: "Natural Oils and Extracts" },
            { id: 3, title: "Fragrance Type", content: "Woody and Floral" }
        ],
        comments: [
            {
                id: 1,
                image: images.product6Review1,
                name: "Layla Hassan",
                date: "July 10, 2025",
                rating: 5,
                content: "Amazing fragrance! Lasts all day without being overpowering."
            },
            {
                id: 2,
                image: images.product6Review2,
                name: "Omar Khalid",
                date: "July 12, 2025",
                rating: 4,
                content: "Great quality attar with a refreshing scent."
            }
        ]
    },
    {
        id: 7,
        image: images.product7Gallery1,
        name: "Elegant Tasbih",
        price: 15.00,
        disprice: 25.00,
        stock: 2,
        content: "Handcrafted Tasbih beads designed for ease of use during Dhikr and prayer, blending tradition with quality craftsmanship.",
        description: "Our elegant Tasbih is made from durable, smooth beads that feel comfortable in your hand. Perfect for daily remembrance, it’s a spiritual companion for Muslims seeking mindfulness in prayer.",
        category: ["Holy Quran", "Fragrant Attar"],
        tags: ["Tasbih", "Prayer", "Beads"],
        gallery: {
            image1: images.product7Gallery1,
            image2: images.product7Gallery2,
            image3: images.product7Gallery3,
            image4: images.product7Gallery4,
        },
        addInfo: [
            { id: 1, title: "Bead Count", content: "99 beads" },
            { id: 2, title: "Material", content: "Natural Wood" },
            { id: 3, title: "Length", content: "30 cm" }
        ],
        comments: [
            {
                id: 1,
                image: images.product7Review1,
                name: "Fatima Noor",
                date: "August 1, 2025",
                rating: 5,
                content: "Beautiful craftsmanship, smooth beads, and perfect size."
            },
            {
                id: 2,
                image: images.product7Review2,
                name: "Ahmed Yusuf",
                date: "August 3, 2025",
                rating: 4,
                content: "Good quality Tasbih, very comfortable to hold."
            }
        ]
    },
    {
        id: 8,
        image: images.product8Gallery1,
        name: "Premium Scarf",
        price: 25.00,
        disprice: 40.00,
        stock: 0,
        content: "Soft and breathable Islamic scarf designed for modesty and comfort during daily wear and prayer.",
        description: "Made from high-quality fabric, this premium Islamic scarf offers excellent coverage with a lightweight feel. Ideal for all seasons, it combines style and tradition seamlessly.",
        category: ["Prayer Mat", "Fragrant Attar"],
        tags: ["Scarf", "Hijab", "Modesty"],
        gallery: {
            image1: images.product8Gallery1,
            image2: images.product8Gallery2,
            image3: images.product8Gallery3,
            image4: images.product8Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Chiffon" },
            { id: 2, title: "Dimensions", content: "180 x 70 cm" },
            { id: 3, title: "Care", content: "Hand wash recommended" }
        ],
        comments: [
            {
                id: 1,
                image: images.product8Review1,
                name: "Aisha Khan",
                date: "July 20, 2025",
                rating: 5,
                content: "Very comfortable and elegant, perfect for everyday use."
            },
            {
                id: 2,
                image: images.product8Review2,
                name: "Mariam Ali",
                date: "July 22, 2025",
                rating: 4,
                content: "Good quality fabric and beautiful color options."
            }
        ]
    },
    {
        id: 9,
        image: images.product9Gallery1,
        name: "Natural Miswak",
        price: 8.00,
        disprice: 12.00,
        stock: 10,
        content: "Authentic natural Miswak sticks for traditional oral hygiene, offering a chemical-free and eco-friendly alternative to toothpaste.",
        description: "Sourced from the Salvadora persica tree, our Miswak sticks effectively clean teeth and gums while promoting oral health. Ideal for daily use, easy to carry, and biodegradable.",
        category: ["Pure Honey", "Sweet Dates"],
        tags: ["Miswak", "Oral Hygiene", "Natural"],
        gallery: {
            image1: images.product9Gallery1,
            image2: images.product9Gallery2,
            image3: images.product9Gallery3,
            image4: images.product9Gallery4,
        },
        addInfo: [
            { id: 1, title: "Length", content: "15 cm" },
            { id: 2, title: "Source", content: "Salvadora persica tree" },
            { id: 3, title: "Usage", content: "Natural teeth cleaning" }
        ],
        comments: [
            {
                id: 1,
                image: images.product9Review1,
                name: "Zain Ahmed",
                date: "August 5, 2025",
                rating: 5,
                content: "Great alternative to toothpaste, keeps my teeth clean naturally."
            },
            {
                id: 2,
                image: images.product9Review2,
                name: "Sara Malik",
                date: "August 6, 2025",
                rating: 4,
                content: "Fresh and effective, easy to use on the go."
            }
        ]
    },
    {
        id: 10,
        image: images.product10Gallery1,
        name: "Quran Hardcover",
        price: 25.00,
        disprice: 35.00,
        stock: 20,
        content: "Beautifully printed Sacred Quran with clear Arabic text and translation for easy reading and spiritual reflection.",
        description: "This hardcover edition of the Sacred Quran features high-quality paper, detailed translation, and elegant calligraphy, perfect for study, recitation, and gifting.",
        category: ["Holy Quran", "Prayer Mat"],
        tags: ["Quran", "Islamic", "Holy Book"],
        gallery: {
            image1: images.product10Gallery1,
            image2: images.product10Gallery2,
            image3: images.product10Gallery3,
            image4: images.product10Gallery4,
        },
        addInfo: [
            { id: 1, title: "Pages", content: "600" },
            { id: 2, title: "Size", content: "8 x 10 inches" },
            { id: 3, title: "Language", content: "Arabic with English Translation" }
        ],
        comments: [
            {
                id: 1,
                image: images.product10Review1,
                name: "Amina Khan",
                date: "July 15, 2025",
                rating: 5,
                content: "Excellent quality and beautifully printed Quran."
            },
            {
                id: 2,
                image: images.product10Review2,
                name: "Omar Farooq",
                date: "July 16, 2025",
                rating: 4,
                content: "Great translation and clear text, very useful for study."
            }
        ]
    },
    {
        id: 11,
        image: images.product11Gallery1,
        name: "Natural Honey",
        price: 18.00,
        disprice: 25.00,
        stock: 15,
        content: "Organic natural honey harvested from pristine environments, rich in flavor and health benefits.",
        description: "Our Pure Natural Honey is sourced from wildflower nectar, packed with antioxidants and nutrients, perfect for sweetening and wellness.",
        category: ["Pure Honey", "Sweet Dates"],
        tags: ["Honey", "Organic", "Natural"],
        gallery: {
            image1: images.product11Gallery1,
            image2: images.product11Gallery2,
            image3: images.product11Gallery3,
            image4: images.product11Gallery4,
        },
        addInfo: [
            { id: 1, title: "Net Weight", content: "500 grams" },
            { id: 2, title: "Origin", content: "Local Wildflowers" },
            { id: 3, title: "Packaging", content: "Glass Jar" }
        ],
        comments: [
            {
                id: 1,
                image: images.product11Review1,
                name: "Sarah Ahmed",
                date: "August 1, 2025",
                rating: 5,
                content: "Delicious and pure honey, perfect for daily use."
            },
            {
                id: 2,
                image: images.product11Review2,
                name: "Ali Mustafa",
                date: "August 2, 2025",
                rating: 4,
                content: "Great natural taste and excellent packaging."
            }
        ]
    },
    {
        id: 12,
        image: images.product12Gallery1,
        name: "Sweet Dates",
        price: 22.00,
        disprice: 30.00,
        stock: 20,
        content: "Naturally sweet and nutritious dates, perfect for snacking and traditional recipes.",
        description: "Our Premium Sweet Dates are handpicked for their rich flavor, soft texture, and high nutritional value, ideal for a healthy lifestyle.",
        category: ["Sweet Dates", "Pure Honey"],
        tags: ["Dates", "Sweet", "Natural"],
        gallery: {
            image1: images.product12Gallery1,
            image2: images.product12Gallery2,
            image3: images.product12Gallery3,
            image4: images.product12Gallery4,
        },
        addInfo: [
            { id: 1, title: "Net Weight", content: "1 kg" },
            { id: 2, title: "Origin", content: "Middle East" },
            { id: 3, title: "Packaging", content: "Vacuum Sealed Pack" }
        ],
        comments: [
            {
                id: 1,
                image: images.product12Review1,
                name: "Amina Khan",
                date: "August 5, 2025",
                rating: 5,
                content: "Soft and sweet, perfect quality dates."
            },
            {
                id: 2,
                image: images.product12Review2,
                name: "Omar Latif",
                date: "August 6, 2025",
                rating: 4,
                content: "Great taste and fresh packaging."
            }
        ]
    },
    {
        id: 13,
        image: images.product13Gallery1,
        name: "Fragrant Attar",
        price: 35.00,
        disprice: 45.00,
        stock: 15,
        content: "Exquisite, natural attar with rich and lasting fragrance for all occasions.",
        description: "Our Fragrant Attar is crafted using traditional distillation methods, offering a pure and captivating scent perfect for daily use or special events.",
        category: ["Fragrant Attar", "Sweet Dates"],
        tags: ["Attar", "Fragrance", "Natural"],
        gallery: {
            image1: images.product13Gallery1,
            image2: images.product13Gallery2,
            image3: images.product13Gallery3,
            image4: images.product13Gallery4,
        },
        addInfo: [
            { id: 1, title: "Volume", content: "15 ml" },
            { id: 2, title: "Ingredients", content: "Pure natural oils" },
            { id: 3, title: "Usage", content: "Apply on pulse points" }
        ],
        comments: [
            {
                id: 1,
                image: images.product13Review1,
                name: "Sara Ali",
                date: "September 1, 2025",
                rating: 5,
                content: "Long-lasting scent and very natural aroma."
            },
            {
                id: 2,
                image: images.product13Review2,
                name: "Ahmed Noor",
                date: "September 3, 2025",
                rating: 4,
                content: "Lovely fragrance, perfect for everyday use."
            }
        ]
    },
    {
        id: 14,
        image: images.product14Gallery1,
        name: "Prayer Rug",
        price: 25.00,
        disprice: 35.00,
        stock: 20,
        content: "Comfortable and beautifully designed prayer rug to enhance your spiritual practice.",
        description: "Our Prayer Rug is crafted from soft, durable materials with intricate patterns that provide comfort and elegance for daily prayers.",
        category: ["Prayer Mat", "Holy Quran"],
        tags: ["Prayer", "Rug", "Comfort"],
        gallery: {
            image1: images.product14Gallery1,
            image2: images.product14Gallery2,
            image3: images.product14Gallery3,
            image4: images.product14Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Soft polyester" },
            { id: 2, title: "Dimensions", content: "70 x 110 cm" },
            { id: 3, title: "Weight", content: "400 grams" }
        ],
        comments: [
            {
                id: 1,
                image: images.product14Review1,
                name: "Amina Khan",
                date: "July 12, 2025",
                rating: 5,
                content: "Very soft and perfect size for my daily prayers."
            },
            {
                id: 2,
                image: images.product14Review2,
                name: "Bilal Ahmed",
                date: "July 15, 2025",
                rating: 4,
                content: "Good quality rug, comfortable and easy to clean."
            }
        ]
    },
    {
        id: 15,
        image: images.product15Gallery1,
        name: "Scented Perfume",
        price: 30.00,
        disprice: 45.00,
        stock: 18,
        content: "A luxurious scented perfume with a long-lasting fragrance to refresh and uplift your spirit.",
        description: "Our Scented Perfume blends rich floral and woody notes, crafted to provide an elegant aroma perfect for daily wear or special occasions.",
        category: ["Fragrant Attar", "Prayer Mat"],
        tags: ["Perfume", "Fragrance", "Aromatic"],
        gallery: {
            image1: images.product15Gallery1,
            image2: images.product15Gallery2,
            image3: images.product15Gallery3,
            image4: images.product15Gallery4,
        },
        addInfo: [
            { id: 1, title: "Fragrance Type", content: "Floral Woody" },
            { id: 2, title: "Volume", content: "50 ml" },
            { id: 3, title: "Longevity", content: "Up to 8 hours" }
        ],
        comments: [
            {
                id: 1,
                image: images.product15Review1,
                name: "Fatima Noor",
                date: "August 3, 2025",
                rating: 5,
                content: "Lovely scent and lasts all day without being overpowering."
            },
            {
                id: 2,
                image: images.product15Review2,
                name: "Ahmed Raza",
                date: "August 5, 2025",
                rating: 4,
                content: "Nice fragrance, perfect for daily use."
            }
        ]
    }

];

export default products;